import { ynToBool } from '@polyv/utils/boolean';
import { mapGetters } from 'vuex';
export default {
  name: 'app',

  computed: {
    ...mapGetters({
      customInfo: 'account/customInfo'
    }),
  },

  watch: {
    customInfo: {
      handler(value) {
        // 更新 favicon
        let favicon = require('@assets/favicons/favicon.ico');
        const { customIcon, customBrandEnabled } = value ?? {};
        if (ynToBool(customBrandEnabled || 'N') && customIcon) {
          favicon = customIcon;
        }
        this.setFavIcon(favicon);
      }
    }
  },

  methods: {
    // 设置 favicon（创建对应 dom 节点）
    setFavIcon(href) {
      let favIconNode = document.querySelector('link[rel*=icon]');
      if (!favIconNode) {
        favIconNode = document.createElement('link');
        window.document.head.appendChild(favIconNode);
      }
      favIconNode.rel = 'shortcut icon';
      favIconNode.type = 'image/x-icon';
      favIconNode.href = href;
    },

    // 加载初始数据，并进行基本处理
    async loadInitialData() {
      const customConfig = await this.$store.dispatch('account/getGroupCustom', {
        domain: window.location.host
      });
      this.$store.commit('account/setCustomInfo', customConfig);

    },

  },

  async created() {
    this.loadInitialData();
  },
};
